import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Navigate, Outlet } from "react-router";
import FullscreenLoading from "../fullscreen-loading";

const AuthLayout = () => {
    const { isAuthenticated, isLoading } = useKindeAuth();

    if (isLoading) return <FullscreenLoading />;
    return isAuthenticated ? (
        <Navigate to="/app/dashboard" />
    ) : (
        <>
            <Outlet />;
            <FullscreenLoading />
        </>
    );
};

export default AuthLayout;
